<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3"/>
    <div class="container">
      <div class="breadcrumb-container">
        <router-link to="/tipoelem">Tipos de Elementos</router-link>
        > {{ datoTipoElem.nombre }}
      </div>
      <div class="notification-area" v-for="(notificacion, index) in notificaciones" :key="index">
        <div class="notification-message" 
             :class="{ 'is-success': notificacion.type === 'success', 'is-error': notificacion.type === 'error' }">
          {{ notificacion.message }}
        </div>
      </div>
    </div>
    <hr>    
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-1">
                  <label for="idTipoElem" class="form-label">Id</label>
                </div>
                <div class="col-1">
                  <input type="text" class="form-control" id="idTipoElem" name="idTipoElem" v-model="datoTipoElem.idTipoElem" disabled>
                </div>
                <div class="col-1">
                  <label for="codigo" class="form-label">Código</label>
                </div>
                <div class="col-1">
                  <input type="text" class="form-control" id="codigo" name="codigo" v-model="datoTipoElem.codigo" style='text-transform:uppercase' required>
                </div>
                <div class="col-1">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-7">
                  <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoTipoElem.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarTipoElem" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditTipoElem" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
<!--           <th scope="col"></th>
          <th scope="col">IdClasElem</th>
          <th scope="col">IdTipoElem</th> -->
          <th scope="col">Nombre</th>
          <th scope="col">Estado</th>
          <!-- <th scope="col">TipoElemNombre</th> -->
        </tr>
      </thead>
      <tbody>
        <tr v-for="claselem in datosPaginados" :key="claselem.idClasElem">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(claselem.idClasElem)" title="Editar">edit_square</i></td>
<!--           <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(claselem.idClasElem)" title="Editar">edit_square</i></td>
          <td>{{claselem.idClasElem}}</td>
          <td>{{claselem.idTipoElem}}</td> -->
          <td>{{claselem.nombre}}</td>
          <td>{{claselem.estado}}</td>
          <!-- <td>{{claselem.tipoElemNombre}}</td> -->
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteTipoElem(claselem.idClasElem)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idClasElem" class="form-label">IdClasElem</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idClasElem" name="idClasElem" v-model="datoClasElem.idClasElem" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idTipoElem" class="form-label">IdTipoElem</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idTipoElem" name="idTipoElem" v-model="datoClasElem.idTipoElem" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <textarea class="form-control" id="nombre" name="nombre" v-model="datoClasElem.nombre" style='text-transform:uppercase'></textarea>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarClasElem" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditClasElem" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: ClasElem -->
    <ClasElemLOVdet @DatosClasElem="GetDataClasElemLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
// Listas de valores master
// Listas de valores master
// Listas de valores details
import ClasElemLOVdet from '../../components/lovs/ClasElemLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
// Listas de valores master
// Listas de valores details
, ClasElemLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      tipoelems : [],
      datoTipoElem : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idTipoElem: '',
// Variables master
// Variables details
      claselems : [],
      datoClasElem : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idTipoElem = this.$route.params.p_idtipoelem
    this.abrirEditar(this.p_idTipoElem)
    this.getClasElems()
    this.getDataPagina(this.paginaActual)
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },
  methods : {
// Procedimientos master
    validarForm(){
      if(this.datoTipoElem.idTipoElem === ''){
        swal("Error!", "El elemento idTipoElem no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTipoElem.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTipoElem.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoTipoElem.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarTipoElem(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tipoelems', this.datoTipoElem)
          swal("Correcto!", "TipoElem creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditTipoElem(){
      if(this.validarForm() === 1){
        try {
          await api.post('/tipoelems', this.datoTipoElem)
          swal("Correcto!", "TipoElem creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoTipoElem={}
      this.titulo   = 'Crear Tipos de Elementos'
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idTipoElem){
      this.modalWindow = true
      if(idTipoElem != null){    
           api.get('/vwtipoelems/'+idTipoElem).then(resp=>{
          this.datoTipoElem = resp.data;
           });
      }
      this.titulo   = 'Editar Tipos de Elementos'
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarTipoElem(){
      this.$router.push('/TipoElem')
    },
// Procedimientos master
// Procedimientos detalle
    async getClasElems() {
      const resp = await api.get('/claselems')
      this.claselems = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.claselems.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwclaselems/nombre/'+this.nombreBusqueda).then(response=>{
          this.claselems=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.claselems.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwclaselems/idtipoelem/'+this.p_idTipoElem).then(response=>{
      this.claselems=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.claselems.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoClasElem.idTipoElem === ''){
        swal("Error!", "El elemento idTipoElem no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoClasElem.codigo === ''){
        swal("Error!", "El elemento codigo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoClasElem.nombre === ''){
        swal("Error!", "El elemento nombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoClasElem.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarClasElem(){
      if(this.validarForm() === 1){
        try {
          this.datoClasElem.idTipoElem = this.datoTipoElem.idTipoElem;
          await api.post('/claselems', this.datoClasElem)
          this.getClasElems();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "ClasElem creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditClasElem(){
      if(this.validarForm() === 1){
        try {
          await api.post('/claselems', this.datoClasElem)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ClasElem creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoClasElem={}
      this.titulo   = 'Crear Tipos de Elementos'
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idClasElem){
      this.modalWindow = true
      if(idClasElem != null){    
           api.get('/vwclaselems/'+idClasElem).then(resp=>{
          this.datoClasElem = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar Tipos de Elementos'
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idClasElem){
      this.modalWindow = true
      if(idClasElem != null){
        this.$router.push('/claselemmd/'+idClasElem)
      }
    },
    async deleteClasElem (idClasElem) {
      try{
        await api.delete('/claselems/'+idClasElem)
          this.getClasElems()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataClasElemLOVdet(data) {
      this.datoClasElem.idClasElem = data.idClasElem;
      this.datoClasElem.clasElem = data.nombre;
    },
// Listas de valores details
  },
}
</script>
